
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCarGoogle as ObiCarGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-car-google.js';
 
 
 

 
 export const ObiCarGoogle = createComponent({
   react: React,
   tagName: 'obi-car-google',
   elementClass: ObiCarGoogleElement,
   events: {
     
   }
  });
 
 